import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/admin/Dashboard";
import Assets from "@/pages/admin/Assets";
import AssetDetail from "@/pages/admin/AssetDetail";
import Assignments from "@/pages/admin/Assignments";
import Maintenance from "@/pages/admin/Maintenance";
import Categories from "@/pages/admin/Categories";
import AssetTypes from "@/pages/admin/AssetTypes";
import ActivityTypes from "@/pages/admin/ActivityTypes";
import Suppliers from "@/pages/admin/Suppliers";
import Users from "@/pages/admin/Users";
import Settings from "@/pages/admin/Settings";
import MyAssets from "@/pages/employee/MyAssets";
import MyDocuments from "@/pages/employee/MyDocuments";
import { Loader2 } from "lucide-react";

// roles: "admin" | "viewer" | "employee"
function Protected({ children, allow }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  if (allow && !allow.includes(user.role)) {
    return <Navigate to={user.role === "employee" ? "/dotazioni" : "/dashboard"} replace />;
  }
  return children;
}

function DefaultRoute() {
  const { user } = useAuth();
  if (user === null) return null;
  if (user === false) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "employee" ? "/dotazioni" : "/dashboard"} replace />;
}

const STAFF = ["admin", "viewer"];
const ADMIN = ["admin"];

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<DefaultRoute />} />
      <Route element={<Protected><Layout /></Protected>}>
        <Route path="/dashboard" element={<Protected allow={STAFF}><Dashboard /></Protected>} />
        <Route path="/beni" element={<Protected allow={STAFF}><Assets /></Protected>} />
        <Route path="/beni/:id" element={<Protected allow={STAFF}><AssetDetail /></Protected>} />
        <Route path="/assegnazioni" element={<Protected allow={STAFF}><Assignments /></Protected>} />
        <Route path="/manutenzioni" element={<Protected allow={STAFF}><Maintenance /></Protected>} />
        <Route path="/dipendenti" element={<Protected allow={ADMIN}><Users /></Protected>} />
        <Route path="/anagrafiche/categorie" element={<Protected allow={ADMIN}><Categories /></Protected>} />
        <Route path="/anagrafiche/tipologie" element={<Protected allow={ADMIN}><AssetTypes /></Protected>} />
        <Route path="/anagrafiche/attivita" element={<Protected allow={ADMIN}><ActivityTypes /></Protected>} />
        <Route path="/anagrafiche/fornitori" element={<Protected allow={ADMIN}><Suppliers /></Protected>} />
        <Route path="/impostazioni" element={<Protected allow={ADMIN}><Settings /></Protected>} />
        <Route path="/dotazioni" element={<MyAssets />} />
        <Route path="/documenti" element={<MyDocuments />} />
      </Route>
      <Route path="*" element={<DefaultRoute />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
